import React, { useEffect, useState } from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";

import api from "../../services/api";

const TicketsClientStatusSelect = ({ selectedStatusIds = [], onChange }) => {
	const [statuses, setStatuses] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/client-statuses");
				setStatuses(Array.isArray(data) ? data : []);
			} catch {
				/* silencioso */
			}
		})();
	}, []);

	return (
		<div style={{ minWidth: 0, width: "100%" }}>
			<FormControl fullWidth margin="dense">
				<Select
					multiple
					displayEmpty
					variant="outlined"
					value={selectedStatusIds}
					onChange={e => onChange(e.target.value)}
					MenuProps={{
						anchorOrigin: { vertical: "bottom", horizontal: "left" },
						transformOrigin: { vertical: "top", horizontal: "left" },
						getContentAnchorEl: null,
					}}
					renderValue={() =>
						selectedStatusIds.length > 0
							? `Status (${selectedStatusIds.length})`
							: "Status"
					}
				>
					{statuses.map(st => (
						<MenuItem dense key={st.id} value={st.id}>
							<Checkbox
								style={{ color: st.color || undefined }}
								size="small"
								color="primary"
								checked={selectedStatusIds.indexOf(st.id) > -1}
							/>
							<ListItemText primary={st.name} />
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default TicketsClientStatusSelect;
